/**
 * @generated SignedSource<<920f2539051db1c191de613ae980d2a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MenuItemType = "ARTICLES" | "EXTERNAL" | "PACKAGES" | "PAGE";
export type UpdateMenuItemInput = {
  icon?: string | null;
  name?: string | null;
  type?: MenuItemType | null;
  url?: string | null;
};
export type MenuItemsEditFormMutation$variables = {
  id: string;
  input: UpdateMenuItemInput;
};
export type MenuItemsEditFormMutation$data = {
  readonly updateMenuItem: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "MenuItemsEditForm_menuItem">;
  };
};
export type MenuItemsEditFormMutation = {
  response: MenuItemsEditFormMutation$data;
  variables: MenuItemsEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MenuItemsEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MenuItem",
        "kind": "LinkedField",
        "name": "updateMenuItem",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MenuItemsEditForm_menuItem"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MenuItemsEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MenuItem",
        "kind": "LinkedField",
        "name": "updateMenuItem",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b65743d4ce84d45886acdd4185e05bb",
    "id": null,
    "metadata": {},
    "name": "MenuItemsEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation MenuItemsEditFormMutation(\n  $id: ID!\n  $input: UpdateMenuItemInput!\n) {\n  updateMenuItem(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...MenuItemsEditForm_menuItem\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment MenuItemsEditForm_menuItem on MenuItem {\n  id\n  name\n  type\n  icon\n  url\n}\n"
  }
};
})();

(node as any).hash = "22a9638fe3139979cdd3bba9e4bde417";

export default node;
